import PropTypes from 'prop-types';
import FacetText from './facet_text';

const FacetTexts = ({ items, context }) => {
  const attributes = items.map((item) => (
    <FacetText key={item.id} context={context} facet={item} />
  ));

  return <ul className="lp-filter-list list-ratings">{attributes}</ul>;
};

FacetTexts.propTypes = {
  items: PropTypes.array,
  context: PropTypes.object
};

export default FacetTexts;
